import React from 'react'
import { Section } from '../../components/Section'
import { SectionContentGalleryLinks } from '../../components/SectionContentGalleryLinks'
import { INTRASITE_LINKS } from '../../constants'

export const SectionContentInstanceMissionAccomplishments: React.FunctionComponent =
  () => (
    <Section backgroundColor="light-gray" padding={100}>
      <SectionContentGalleryLinks
        title="We’re honored to be recognized for our achievements as a company."
        images={[
          {
            id: 'gptw',
            heading: 'Great Place to Work Certified',
            image: {
              publicId: 'photography/merits-gptw',
              alt: 'Qwick is Great Place to Work Certified',
            },
            href: `${INTRASITE_LINKS.blog.pagePath}/qwick-earns-great-place-to-work-certification`,
          },
          {
            id: 'murtec',
            heading: 'MURTEC Industry Hero Award',
            image: {
              publicId:
                'photography/accomplishments-murtec-industry-hero-award',
              alt: 'The MURTEC Industry Hero Award',
            },
            href: `${INTRASITE_LINKS.blog.pagePath}/qwick-receives-hospitality-industry-hero-award`,
          },
          {
            id: 'sc50',
            heading: "South Carolina's Fastest Growing Companies",
            image: {
              publicId: 'photography/merits-sc50',
              alt: 'Ranked #1 fastest growing company in South Carolina 2023',
            },
          },
        ]}
      />
    </Section>
  )
